import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import locale from './locale'
import PotentialClientModal from 'template/Modals/PotentialClient'
import transferToStudent from 'controllers/client/transferToStudent'
import deleteClient from 'controllers/client/deleteClient'
import __R, {userCan} from 'containers/__R';

export default function() {
  return getDefaultTableSettings.call(this);
}

function getDefaultTableSettings() {
  const schoolId = localStorage.getItem('schoolId')
  const {keyword, pagination} = this.state;
  const {itemsCountPerPage} = pagination;

  let dropdown = [
    {
      title: __("Edit Contact", locale),
      onClick: ({ trData: client })=>{
        PotentialClientModal({clientId: client.contact_id, type: 'edit', pagination, keyword})
        .then((res)=>{
          this.props.fetchClientList({
            schoolId,
            student_state: 'notTransfer',
            amount_per_page: itemsCountPerPage,
            page_number: 1,
            keyword
          })
        })
      },
      isDisabled: (opts) => {
        return !userCan('edit_contact')
      }
    },
    {
      title: __("Transfer to student", locale),
      onClick: ({ trData: client })=>{
        confirm(__('Proceed to transfer to student?', locale), __("Transfer to student", locale))
        .then((res) => {
          transferToStudent(client.contact_id, {student_state: 'transferred'})
          .then((res) => {
            if(res.result == 'success'){
              this.props.fetchClientList({
                schoolId,
                student_state: 'notTransfer',
                amount_per_page: itemsCountPerPage,
                page_number: 1,
                keyword
              })
            } else if (res.result == 'failure' && res.reason == 'need to upgrade to higher SaaS version.'){
              alert.warning(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'))
            }
          })
        })
        .catch(()=>{})
      },
      isDisabled: (opts) => {
        return !userCan('convert_contact_to_student')
      }
    },
    {
      title: __("Delete", locale),
      onClick: ({ trData: client })=>{
        confirm(__('Proceed to delete contact: {client}?', locale, {client: client.name}), __('Delete Contact', locale)).then(() => {
          deleteClient(client.contact_id)
          .then((res) => {
            if(res.result == 'success'){
              this.props.fetchClientList({
                schoolId,
                student_state: 'notTransfer',
                amount_per_page: itemsCountPerPage,
                page_number: 1,
                keyword
              })
            }
          })
        })
        .catch(()=>{})
      },
      isDisabled: (opts) => {
        return !userCan('edit_contact')
      }
    },
  ];

  return [
    {
      title: __('Options', 'teacher'),
      id: "client-dropdown",
      dropdown
    }
  ]
}


// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/table-settings.js